import { FC } from "react";
import { Flex, Text } from "@chakra-ui/react";

import { FONT_WEIGHT } from "@assets/theme/foundations/textStyle";

import CaseDocumentProgressBar from "../CaseDocumentProgressBar";

const getMeterColor = (value: number, limit: number, warnAt?: number) => {
  if (value > limit) return "brand.error";
  if (warnAt !== undefined && value >= warnAt) return "score.midText";
  return "brand.checkMark";
};

interface MedicalRecordsLimitMeterProps {
  label: string;
  value: number;
  limit: number;
  format?: (value: number) => string;
  /** Turns the meter amber from this value up to the limit */
  warnAt?: number;
}

const MedicalRecordsLimitMeter: FC<MedicalRecordsLimitMeterProps> = ({
  label,
  value,
  limit,
  format = String,
  warnAt,
}) => (
  <Flex direction="column" gap="6px">
    <Flex justify="space-between" fontSize="13px">
      <Text color="brand.textSecondary">{label}</Text>
      <Text color="brand.modalHeaderText" fontWeight={FONT_WEIGHT.HEAVY}>
        {format(value)} / {format(limit)}
      </Text>
    </Flex>
    <CaseDocumentProgressBar value={(value / limit) * 100} color={getMeterColor(value, limit, warnAt)} />
  </Flex>
);

export default MedicalRecordsLimitMeter;
